// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasicFormContainer_myContainer__F3z\\+z {
  padding: 20px;
  max-width: 600px;
  position: relative;
  white-space: pre;
}`, "",{"version":3,"sources":["webpack://./src/components/common/BasicFormContainer/BasicFormContainer.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AADF","sourcesContent":["@import '../../../styles/colors';\n\n.myContainer {\n  padding: 20px;\n  max-width: 600px;\n  position: relative;\n  white-space: pre;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"myContainer": `BasicFormContainer_myContainer__F3z+z`
};
export default ___CSS_LOADER_EXPORT___;
